import React from 'react';
import env from '../../env';
import ExternalTeaser from './components/ExternalTeaser/ExternalTeaser';
import PollQuestion from './components/PollQuestion/PollQuestion';
import { ExternalTeasersList, Heading, StyledExternalTeasers } from './ExternalTeasers.styles';

const ExternalTeasers = () => (
    <StyledExternalTeasers className="lp_ext">
        <Heading>Annat från SVT</Heading>
        <ExternalTeasersList>
            <ExternalTeaser
                url="https://nyhetsbrev.svtplay.se/prenumerera/?utm_source=svtplay&utm_medium=homepage-cta"
                title="Prenumerera på SVT Plays nyhetsbrev"
                linkTitle=""
                description="Få tips på nytt & kommande rätt in i din inkorg varje vecka."
                image={require('public/static/images/external-teasers/nyhetsbrev.jpg')}
                index={1}
                isExternal={true}
            />
            <ExternalTeaser
                url="https://kontakt.svt.se/guide/about-svt-sprakplay-in-english-and-swedish"
                title="Subtitles in your language"
                linkTitle=""
                description="SVT Språkplay offers interactive subtitles in 18 languages."
                image={require('public/static/images/external-teasers/sprakplay.jpg')}
                index={2}
                isExternal={true}
            />
            <ExternalTeaser
                url="https://www.svt.se/barnkanalen"
                title="SVT Barn - barnens egen app"
                linkTitle=""
                description="Ladda ner appen med bara barnprogram."
                image={require('public/static/images/external-teasers/barnplay.jpg')}
                index={3}
                isExternal={true}
            />
            <ExternalTeaser
                url="https://kontakt.svt.se/category/svt-play"
                title="Behöver du hjälp?"
                linkTitle=""
                description="Här hittar du vanliga frågor och svar kring vår tjänst."
                image={require('public/static/images/external-teasers/atv-kollage.jpg')}
                index={4}
                isExternal={true}
            />
            {env.STARTPAGE_POLL_URL !== '' && <PollQuestion />}
        </ExternalTeasersList>
    </StyledExternalTeasers>
);

export default React.memo(ExternalTeasers);
